import { SharingMethod } from 'api/sharingContentApi'

export const mapSharingItems = (list: SharingMethod[]) => {
  return list.map((item) => {
    const encoded = encodeURIComponent(item.url)
    switch (item.sharingMethod) {
      case 'facebook':
        return {
          ...item,
          url: `https://www.facebook.com/sharer/sharer.php?u=${encoded}`,
        }
      case 'viber':
        return { ...item, url: `viber://forward?text=${encoded}` }
      case 'whatsapp':
        return {
          ...item,
          url: `https://api.whatsapp.com/send?text=${encoded}`,
        }
    }
    return { ...item }
  })
}

/**
 * Доступные методы для share для отображения на клиенте
 * Отображаются только те, которые указаны, остальные - игнорируются
 * Также используется для фильтрации данных с сервера
 */
export const SharingMethodSocialMap: Record<
  'whatsapp' | 'viber' | 'url',
  Record<string, string>
> = {
  whatsapp: {
    title: 'Whats App',
  },
  viber: {
    title: 'Viber',
  },
  url: {
    title: '',
  },
} as const
